import React from 'react';
import SectionHeader from '../../../common/marketing/SectionHeader';
import { renderMarketingIcon } from '../../../../utils/marketingIcons';
import { trackEvent } from '../../../../utils/firebase';

const trackLead = (method) => () => trackEvent('generate_lead', { method, location: 'warranty' });

const OrbitStarWarrantySection = ({ section }) => (
    <section id="warranty" className="orbit-star-warranty">
        <div className="container">
            <SectionHeader
                wrapperClassName="orbit-star-section-header"
                subtitleClassName="orbit-star-section-subtitle"
                titleClassName="orbit-star-section-title"
                subtitle={section.subtitle}
                title={section.title}
            />

            <div className="orbit-star-warranty-grid">
                <div className="orbit-star-warranty-badge">
                    <span className="orbit-star-warranty-badge-icon">{renderMarketingIcon('shield', 30)}</span>
                    <div className="orbit-star-warranty-badge-value">
                        {section.badgeValue}
                        <span>{section.badgeUnit}</span>
                    </div>
                    <div className="orbit-star-warranty-badge-label">{section.badgeLabel}</div>
                    <p>{section.description}</p>
                </div>

                <div className="orbit-star-warranty-card">
                    <h3 className="orbit-star-warranty-card-title">
                        <span className="orbit-star-warranty-card-icon">{renderMarketingIcon('warning', 20)}</span>
                        {section.termsTitle}
                    </h3>
                    <ul className="orbit-star-warranty-terms">
                        {section.terms.map((term) => <li key={term}>{term}</li>)}
                    </ul>
                </div>

                <div className="orbit-star-warranty-card">
                    <h3 className="orbit-star-warranty-card-title">
                        <span className="orbit-star-warranty-card-icon">{renderMarketingIcon('home', 20)}</span>
                        {section.claimTitle}
                    </h3>
                    <p className="orbit-star-warranty-claim-intro">{section.claimDescription}</p>
                    <address className="orbit-star-warranty-address">
                        <strong>{section.addressName}</strong>
                        {section.addressLines.map((line) => <span key={line}>{line}</span>)}
                    </address>
                    <a
                        className="orbit-star-warranty-directions"
                        href={section.directionsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {section.directionsLabel}
                    </a>

                    <div className="orbit-star-warranty-support">
                        <span className="orbit-star-warranty-support-label">{section.supportLabel}</span>
                        <a className="orbit-star-warranty-support-number" href={section.supportPhoneUrl} onClick={trackLead('call')}>
                            {section.supportNumberDisplay}
                        </a>
                        <p>{section.whatsappNote}</p>
                    </div>

                    <div className="orbit-star-warranty-actions">
                        <a
                            className="orbit-star-warranty-btn orbit-star-warranty-btn--whatsapp"
                            href={section.whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={trackLead('whatsapp')}
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="currentColor">
                                <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 2s.8 2.3.9 2.5c.1.2 1.6 2.5 4 3.5 1.5.6 2.1.7 2.8.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.5-.3z" />
                            </svg>
                            {section.whatsappLabel}
                        </a>
                        <a className="orbit-star-warranty-btn orbit-star-warranty-btn--ghost" href={section.supportPhoneUrl} onClick={trackLead('call')}>
                            {section.callLabel}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default OrbitStarWarrantySection;
